import { makeAutoObservable } from 'mobx';
import { Media, createMedia } from '../Media/Media';
import { LocalizedValue, createLocalizedValue } from '../LocalizedValue';
import { languagePriority } from '../LocalizedEntity';
import { languageState } from '../../Contexts/LanguageContext';

/**
 * Created by neo on 19.04.21.
 */

export type Instructor = {
  name: string;
  description: LocalizedValue[];
  image?: Media;
  readonly translatedDescription: string;
};

export function createInstructor(json?: Partial<Instructor>): Instructor {
  return makeAutoObservable({
    name: json?.name ?? '',
    description: (json?.description ?? []).map((l: any) => createLocalizedValue(l)),
    image: json?.image ? createMedia(json.image) : undefined,

    get translatedDescription(): string {
      const language = languageState.language;
      const langFit = this.description.find((n) => n.lang === language.toLowerCase())?.value;
      if (langFit?.trim()) return langFit;

      for (const lang of languagePriority) {
        const entry = this.description.find((l) => l.lang === lang);
        if (entry) return entry.value ?? '';
      }
      return this.description[0]?.value ?? '';
    },
  });
}
